<template>
  <div class="page-content">
    <div class="scroll-indicator" id="scrollIndicator"></div>

    <!-- 顶部区域 -->
    <header class="header-section py-12">
      <div class="container mx-auto">
        <div class="flex flex-col md:flex-row items-start md:items-center justify-between">
          <!-- 左侧Logo和企业名称 -->
          <div class="flex items-center mb-6 md:mb-0">
            <div class="w-24 h-24 bg-white rounded-lg flex items-center justify-center mr-6">
              <img src="../assets/images/service/bcjt-logo.jpg" alt="展会Logo" class="w-24 h-24 object-contain">
            </div>
            <div>
              <h1 class="text-3xl font-bold mb-2">北京北辰会展信息服务有限公司</h1>
              <div class="flex flex-wrap items-center gap-2">
                <span class="bg-blue-700 text-white text-sm px-3 py-1 rounded-full">认证企业</span>
                <div class="flex items-center">
                  <span class="rating-stars mr-1"><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i></span>
                  <span class="text-sm">五颗星</span>
                </div>
                <span class="text-sm">10年经验</span>
              </div>
            </div>
          </div>

          <!-- 右侧功能按钮 -->
          <div class="flex gap-4">
            <button class="contact-btn bg-white text-blue-600 font-medium px-6 py-3 rounded-lg flex items-center">
              <i class="fas fa-comment-dots mr-2"></i>立即联系
            </button>
            <button class="favorite-btn bg-blue-700 text-white font-medium px-6 py-3 rounded-lg flex items-center">
              <i class="far fa-star mr-2"></i>收藏
            </button>
          </div>
        </div>

        <!-- 交易数据统计 -->
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
          <div class="stat-card p-6 text-center">
            <div class="text-3xl font-bold mb-2">12</div>
            <div class="text-sm">提供服务</div>
          </div>
          <div class="stat-card p-6 text-center">
            <div class="text-3xl font-bold mb-2">82</div>
            <div class="text-sm">服务企业</div>
          </div>
          <div class="stat-card p-6 text-center">
            <div class="text-3xl font-bold mb-2">128</div>
            <div class="text-sm">成交次数</div>
          </div>
          <div class="stat-card p-6 text-center">
            <div class="text-3xl font-bold mb-2">96</div>
            <div class="text-sm">累计评价</div>
          </div>
        </div>

        <!-- 服务行业标签 -->
        <div class="mt-8 flex flex-wrap items-center gap-3">
          <span class="text-sm">服务行业：</span>
          <span class="bg-white bg-opacity-20 text-white text-sm px-3 py-1 rounded-full">信息服务</span>
          <span class="bg-white bg-opacity-20 text-white text-sm px-3 py-1 rounded-full">配套服务</span>
          <span class="bg-white bg-opacity-20 text-white text-sm px-3 py-1 rounded-full">软件系统</span>
        </div>
      </div>
    </header>

    <!-- 导航菜单 -->
    <nav class="bg-white shadow-md sticky top-0 z-50">
      <div class="container mx-auto">
        <div class="flex justify-center">
          <div class="flex space-x-8 py-4">
            <a href="#company-info" class="nav-link text-blue-600 font-medium">企业基础信息</a>
            <a href="#services" class="nav-link text-blue-600 font-medium">展会服务</a>
            <a href="#reviews" class="nav-link text-blue-600 font-medium">评价记录</a>
            <a href="#downloads" class="nav-link text-blue-600 font-medium">资料下载</a>
          </div>
        </div>
      </div>
    </nav>

    <!-- 企业基础信息（合并了企业简介和工商信息） -->
    <section id="company-info" class="py-16 bg-gray-50">
      <div class="container mx-auto">
        <h2 class="text-3xl font-bold mb-8 flex items-center">
          <i class="fas fa-building text-blue-600 mr-3"></i>
          企业基础信息
        </h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          <!-- 左侧：企业简介 -->
          <div class="info-card p-8">
            <h3 class="text-xl font-semibold mb-4 text-blue-800">企业简介</h3>

            <!-- 联系信息部分 -->
            <div class="bg-blue-50 p-6 rounded-lg mb-6">
              <h4 class="font-medium mb-3 text-blue-800">联系信息</h4>
              <div class="space-y-3">
                <div class="flex items-start">
                  <i class="fas fa-map-marker-alt text-blue-600 mt-1 mr-3 w-5 text-center"></i>
                  <span class="text-gray-700">北京市朝阳区天辰东路7号国家会议中心一期北区写字楼（E5门）4层</span>
                </div>
                <div class="flex items-center">
                  <i class="fas fa-phone text-blue-600 mr-3 w-5 text-center"></i>
                  <span class="text-gray-700">010-64994602</span>
                </div>
                <div class="flex items-center">
                  <i class="fas fa-globe text-blue-600 mr-3 w-5 text-center"></i>
                  <a href="http://shouhuigroup.com" class="text-blue-600 hover:text-blue-800 underline">http://shouhuigroup.com</a>
                </div>
                <div class="flex items-center">
                  <i class="fas fa-envelope text-blue-600 mr-3 w-5 text-center"></i>
                  <a href="mailto:ciftis@nsevents.cn" class="text-blue-600 hover:text-blue-800 underline">ciftis@nsevents.cn</a>
                </div>
              </div>
            </div>

            <!-- 企业简介文本 -->
            <p class="text-gray-700 leading-relaxed">
              北京北辰会展信息服务有限公司作为首都会展集团的全资子公司，并承担首都会展集团数字化与信息管理部的工作职责。公司持续打造以会议和展览为核心引擎的"会展+"业务产品体系，在会展全产业链数字化工作上深耕细作，不断强化会展主承办、场馆运营管理等系统平台的功能建设，目前主要产品为：场馆业务管理系统、票证管理系统、报馆管理系统、会议管理系统等。以上产品在服贸会、医美展、潮玩展等展会上都得到了很好的应用。我们始终为首都会展集团的数字化转型提供持续运营的核心动能，逐步实现数字化转型发展标杆的重点任务。
            </p>
          </div>

          <!-- 右侧：工商信息 -->
          <div class="info-card p-8">
            <h3 class="text-xl font-semibold mb-4 text-blue-800">工商信息</h3>
            <div class="overflow-x-auto">
              <table class="w-full">
                <tbody>
                <tr class="border-b border-gray-200">
                  <td class="py-4 px-6 font-medium text-gray-700 w-1/3">注册资本</td>
                  <td class="py-4 px-6 text-gray-600">1000万元人民币</td>
                </tr>
                <tr class="border-b border-gray-200">
                  <td class="py-4 px-6 font-medium text-gray-700">法定代表人</td>
                  <td class="py-4 px-6 text-gray-600">张三</td>
                </tr>
                <tr class="border-b border-gray-200">
                  <td class="py-4 px-6 font-medium text-gray-700">企业类型</td>
                  <td class="py-4 px-6 text-gray-600">有限责任公司(法人独资)</td>
                </tr>
                <tr class="border-b border-gray-200">
                  <td class="py-4 px-6 font-medium text-gray-700">成立时间</td>
                  <td class="py-4 px-6 text-gray-600">2014年3月15日</td>
                </tr>
                <tr class="border-b border-gray-200">
                  <td class="py-4 px-6 font-medium text-gray-700">股东信息</td>
                  <td class="py-4 px-6 text-gray-600">首都会展集团有限公司 (100%)</td>
                </tr>
                <tr>
                  <td class="py-4 px-6 font-medium text-gray-700">经营范围</td>
                  <td class="py-4 px-6 text-gray-600">信息系统集成服务；软件开发；数据处理；技术开发、技术服务、技术咨询、技术转让；会议服务；承办展览展示活动；计算机系统服务；销售计算机、软件及辅助设备、电子产品、通讯设备；设计、制作、代理、发布广告；经济贸易咨询；企业管理咨询；市场调查。（企业依法自主选择经营项目，开展经营活动；依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动；不得从事本市产业政策禁止和限制类项目的经营活动。）</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 展会服务 -->
    <section id="services" class="py-16">
      <div class="container mx-auto">
        <div class="flex flex-col md:flex-row md:items-center justify-between mb-8">
          <h2 class="text-3xl font-bold flex items-center">
            <i class="fas fa-concierge-bell text-blue-600 mr-3"></i>
            展会服务
          </h2>
          <button class="view-all-btn bg-blue-600 text-white font-medium px-6 py-3 rounded-lg mt-4 md:mt-0">
            <i class="fas fa-angle-right mr-2"></i>查看全部
          </button>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          <!-- 服务卡片1 -->
          <div class="service-card p-6">
            <h3 class="text-xl font-semibold mb-2">场馆管理系统</h3>
            <p class="text-gray-600 mb-4">专业的场馆运营管理解决方案</p>
            <div class="flex flex-wrap mb-4">
              <span class="industry-tag">信息系统服务</span>
              <span class="industry-tag">场馆管理</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-blue-600 font-medium">¥ 咨询报价</span>
              <span class="text-gray-500 text-sm">已成交 28 次</span>
            </div>
          </div>

          <!-- 服务卡片2 -->
          <div class="service-card p-6">
            <h3 class="text-xl font-semibold mb-2">综合服务系统</h3>
            <p class="text-gray-600 mb-4">一站式会展综合服务平台</p>
            <div class="flex flex-wrap mb-4">
              <span class="industry-tag">综合服务</span>
              <span class="industry-tag">平台系统</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-blue-600 font-medium">¥ 咨询报价</span>
              <span class="text-gray-500 text-sm">已成交 22 次</span>
            </div>
          </div>

          <!-- 服务卡片3 -->
          <div class="service-card p-6">
            <h3 class="text-xl font-semibold mb-2">证件管理系统</h3>
            <p class="text-gray-600 mb-4">高效的会展证件制作与管理系统</p>
            <div class="flex flex-wrap mb-4">
              <span class="industry-tag">证件管理</span>
              <span class="industry-tag">安全服务</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-blue-600 font-medium">¥ 咨询报价</span>
              <span class="text-gray-500 text-sm">已成交 19 次</span>
            </div>
          </div>

          <!-- 服务卡片4 -->
          <div class="service-card p-6">
            <h3 class="text-xl font-semibold mb-2">闸机验证通道</h3>
            <p class="text-gray-600 mb-4">人脸识别闸机验证解决方案</p>
            <div class="flex flex-wrap mb-4">
              <span class="industry-tag">安防设备</span>
              <span class="industry-tag">人脸识别</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-blue-600 font-medium">¥ 咨询报价</span>
              <span class="text-gray-500 text-sm">已成交 15 次</span>
            </div>
          </div>

          <!-- 服务卡片5 -->
          <div class="service-card p-6">
            <h3 class="text-xl font-semibold mb-2">PVC证件（芯片卡）</h3>
            <p class="text-gray-600 mb-4">带芯片的PVC材质会展证件</p>
            <div class="flex flex-wrap mb-4">
              <span class="industry-tag">证件制作</span>
              <span class="industry-tag">智能卡</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-blue-600 font-medium">¥ 咨询报价</span>
              <span class="text-gray-500 text-sm">已成交 14 次</span>
            </div>
          </div>

          <!-- 服务卡片6 -->
          <div class="service-card p-6">
            <h3 class="text-xl font-semibold mb-2">会展主承办平台</h3>
            <p class="text-gray-600 mb-4">会展主办与承办全流程管理平台</p>
            <div class="flex flex-wrap mb-4">
              <span class="industry-tag">会展管理</span>
              <span class="industry-tag">平台系统</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-blue-600 font-medium">¥ 咨询报价</span>
              <span class="text-gray-500 text-sm">已成交 12 次</span>
            </div>
          </div>

          <!-- 服务卡片7 -->
          <div class="service-card p-6">
            <h3 class="text-xl font-semibold mb-2">定制化开发服务</h3>
            <p class="text-gray-600 mb-4">根据客户需求定制开发会展系统</p>
            <div class="flex flex-wrap mb-4">
              <span class="industry-tag">软件开发</span>
              <span class="industry-tag">定制服务</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-blue-600 font-medium">¥ 咨询报价</span>
              <span class="text-gray-500 text-sm">已成交 10 次</span>
            </div>
          </div>

          <!-- 服务卡片8 -->
          <div class="service-card p-6">
            <h3 class="text-xl font-semibold mb-2">AI实时翻译系统</h3>
            <p class="text-gray-600 mb-4">多语言AI实时翻译解决方案</p>
            <div class="flex flex-wrap mb-4">
              <span class="industry-tag">AI服务</span>
              <span class="industry-tag">翻译服务</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-blue-600 font-medium">¥ 咨询报价</span>
              <span class="text-gray-500 text-sm">已成交 8 次</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 评价记录 -->
    <section id="reviews" class="py-16 bg-gray-50">
      <div class="container mx-auto">
        <div class="flex flex-col md:flex-row md:items-center justify-between mb-8">
          <h2 class="text-3xl font-bold flex items-center">
            <i class="fas fa-star text-blue-600 mr-3"></i>
            评价记录
          </h2>
          <button class="view-all-btn bg-blue-600 text-white font-medium px-6 py-3 rounded-lg mt-4 md:mt-0">
            <i class="fas fa-angle-right mr-2"></i>查看全部
          </button>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          <!-- 评价1 -->
          <div class="info-card p-6">
            <div class="flex items-center mb-4">
              <div class="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mr-4">
                <span class="text-lg font-bold text-gray-500">A</span>
              </div>
              <div>
                <h4 class="font-semibold">北京国际展览有限公司</h4>
                <div class="flex items-center mt-1">
                  <span class="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded mr-2">会展服务</span>
                  <span class="rating-stars text-sm"><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i></span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <span class="text-sm text-gray-500">展会名称：</span>
              <span class="exhibition-tag">2024北京国际服务贸易交易会</span>
            </div>
            <p class="text-gray-600 mb-4">北辰会展的场馆管理系统非常专业，帮助我们高效管理了展会现场，系统稳定可靠，服务团队响应迅速，值得推荐！</p>
            <div class="text-right text-sm text-gray-500">2024-09-15</div>
          </div>

          <!-- 评价2 -->
          <div class="info-card p-6">
            <div class="flex items-center mb-4">
              <div class="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mr-4">
                <span class="text-lg font-bold text-gray-500">B</span>
              </div>
              <div>
                <h4 class="font-semibold">上海国际会议中心</h4>
                <div class="flex items-center mt-1">
                  <span class="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded mr-2">会议服务</span>
                  <span class="rating-stars text-sm"><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="far fa-star"></i></span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <span class="text-sm text-gray-500">展会名称：</span>
              <span class="exhibition-tag">2024全球科技创新大会</span>
            </div>
            <p class="text-gray-600 mb-4">证件管理系统使用体验良好，操作简便，大大提高了我们的工作效率。唯一的小建议是希望能增加更多自定义报表功能。</p>
            <div class="text-right text-sm text-gray-500">2024-08-22</div>
          </div>

          <!-- 评价3 -->
          <div class="info-card p-6">
            <div class="flex items-center mb-4">
              <div class="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mr-4">
                <span class="text-lg font-bold text-gray-500">C</span>
              </div>
              <div>
                <h4 class="font-semibold">广州国际展览中心</h4>
                <div class="flex items-center mt-1">
                  <span class="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded mr-2">展览服务</span>
                  <span class="rating-stars text-sm"><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i></span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <span class="text-sm text-gray-500">展会名称：</span>
              <span class="exhibition-tag">2024中国进出口商品交易会</span>
            </div>
            <p class="text-gray-600 mb-4">闸机验证通道系统非常高效，人脸识别准确率高，大大加快了观众入场速度，得到了主办方和参展商的一致好评。</p>
            <div class="text-right text-sm text-gray-500">2024-07-10</div>
          </div>

          <!-- 评价4 -->
          <div class="info-card p-6">
            <div class="flex items-center mb-4">
              <div class="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mr-4">
                <span class="text-lg font-bold text-gray-500">D</span>
              </div>
              <div>
                <h4 class="font-semibold">深圳国际会议展览中心</h4>
                <div class="flex items-center mt-1">
                  <span class="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded mr-2">综合服务</span>
                  <span class="rating-stars text-sm"><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="far fa-star"></i><i class="far fa-star"></i></span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <span class="text-sm text-gray-500">展会名称：</span>
              <span class="exhibition-tag">2024中国（深圳）国际文化产业博览交易会</span>
            </div>
            <p class="text-gray-600 mb-4">综合服务系统功能全面，但初期使用需要一定的学习成本，建议加强用户培训和操作指南的提供。</p>
            <div class="text-right text-sm text-gray-500">2024-06-05</div>
          </div>

          <!-- 评价5 -->
          <div class="info-card p-6">
            <div class="flex items-center mb-4">
              <div class="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mr-4">
                <span class="text-lg font-bold text-gray-500">E</span>
              </div>
              <div>
                <h4 class="font-semibold">成都国际会展中心</h4>
                <div class="flex items-center mt-1">
                  <span class="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded mr-2">定制开发</span>
                  <span class="rating-stars text-sm"><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i></span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <span class="text-sm text-gray-500">展会名称：</span>
              <span class="exhibition-tag">2024成都国际汽车展览会</span>
            </div>
            <p class="text-gray-600 mb-4">定制化开发服务非常专业，团队能够准确理解我们的需求，并提供了超出预期的解决方案，系统上线后运行稳定。</p>
            <div class="text-right text-sm text-gray-500">2024-05-18</div>
          </div>

          <!-- 评价6 -->
          <div class="info-card p-6">
            <div class="flex items-center mb-4">
              <div class="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mr-4">
                <span class="text-lg font-bold text-gray-500">F</span>
              </div>
              <div>
                <h4 class="font-semibold">杭州国际博览中心</h4>
                <div class="flex items-center mt-1">
                  <span class="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded mr-2">AI服务</span>
                  <span class="rating-stars text-sm"><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="far fa-star"></i></span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <span class="text-sm text-gray-500">展会名称：</span>
              <span class="exhibition-tag">2024杭州国际电子商务博览会</span>
            </div>
            <p class="text-gray-600 mb-4">AI实时翻译系统在多语言环境下表现出色，翻译准确率高，响应速度快，为国际展会提供了很好的语言支持服务。</p>
            <div class="text-right text-sm text-gray-500">2024-04-25</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 资料下载 -->
    <section id="downloads" class="py-16">
      <div class="container mx-auto">
        <h2 class="text-3xl font-bold mb-8 flex items-center">
          <i class="fas fa-download text-blue-600 mr-3"></i>
          资料下载
        </h2>
        <div class="max-w-6xl mx-auto">
          <div class="info-card p-8">
            <div class="space-y-4">
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <div class="w-10 h-10 bg-blue-100 rounded flex items-center justify-center mr-4">
                    <i class="fas fa-file-pdf text-blue-600"></i>
                  </div>
                  <div>
                    <span class="font-medium">产品手册.pdf</span>
                    <span class="file-size">2.5MB</span>
                  </div>
                </div>
                <button class="download-btn bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center">
                  <i class="fas fa-download mr-2"></i>下载
                </button>
              </div>

              <div class="border-t border-gray-200 pt-4 flex items-center justify-between">
                <div class="flex items-center">
                  <div class="w-10 h-10 bg-blue-100 rounded flex items-center justify-center mr-4">
                    <i class="fas fa-file-pdf text-blue-600"></i>
                  </div>
                  <div>
                    <span class="font-medium">企业介绍.pdf</span>
                    <span class="file-size">1.8MB</span>
                  </div>
                </div>
                <button class="download-btn bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center">
                  <i class="fas fa-download mr-2"></i>下载
                </button>
              </div>

              <div class="border-t border-gray-200 pt-4 flex items-center justify-between">
                <div class="flex items-center">
                  <div class="w-10 h-10 bg-blue-100 rounded flex items-center justify-center mr-4">
                    <i class="fas fa-file-pdf text-blue-600"></i>
                  </div>
                  <div>
                    <span class="font-medium">服务案例合集.pdf</span>
                    <span class="file-size">3.2MB</span>
                  </div>
                </div>
                <button class="download-btn bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center">
                  <i class="fas fa-download mr-2"></i>下载
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "Monthly",
  mounted() {
    // 平滑滚动
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    });

    // 滚动指示器
    window.addEventListener('scroll', function() {
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = (winScroll / height) * 100;
      const bar = document.getElementById("scrollIndicator");
      if (bar) {
        bar.style.width = scrolled + "%";
      }
    });

    // 收藏按钮交互
    const favoriteBtn = document.querySelector('.favorite-btn');
    if (favoriteBtn) {
      favoriteBtn.addEventListener('click', function() {
        const icon = this.querySelector('i');
        if (!icon) return;

        if (icon.classList.contains('far')) {
          icon.classList.remove('far');
          icon.classList.add('fas');
          this.classList.add('bg-red-500');
          this.classList.remove('bg-blue-700');
          this.innerHTML = '<i class="fas fa-star mr-2"></i>已收藏';
        } else {
          icon.classList.remove('fas');
          icon.classList.add('far');
          this.classList.remove('bg-red-500');
          this.classList.add('bg-blue-700');
          this.innerHTML = '<i class="far fa-star mr-2"></i>收藏';
        }
      });
    }

    // 下载按钮交互
    const downloadBtns = document.querySelectorAll('.download-btn');
    downloadBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const originalText = this.innerHTML;
        this.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>下载中...';
        this.disabled = true;

        // 模拟下载过程
        setTimeout(() => {
          this.innerHTML = '<i class="fas fa-check mr-2"></i>已下载';
          this.classList.add('bg-green-600');
          this.classList.remove('bg-blue-600');

          // 恢复按钮状态
          setTimeout(() => {
            this.innerHTML = originalText;
            this.disabled = false;
            this.classList.remove('bg-green-600');
            this.classList.add('bg-blue-600');
          }, 2000);
        }, 1500);
      });
    });

    // 查看全部按钮交互
    const viewAllBtns = document.querySelectorAll('.view-all-btn');
    viewAllBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        // 这里可以添加查看全部的逻辑
        this.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>加载中...';
        this.disabled = true;

        // 模拟加载过程
        setTimeout(() => {
          this.innerHTML = '<i class="fas fa-angle-right mr-2"></i>查看全部';
          this.disabled = false;
        }, 1000);
      });
    });
  }
}
</script>

<style scoped>
.flex-center{
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.bg-gradient-primary {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  border-radius: 20px 20px 0px 0px;
  margin-bottom: 20px;
}

.page-content{
  padding-top: 20px;
  padding-bottom: 20px;
}

body {
  font-family: 'Noto Sans SC', sans-serif;
  background-color: #F9FAFB;
  color: #1F2937;
}

.container {
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 20px;
}

.header-section {
  background: linear-gradient(135deg, #2563EB 0%, #204E9C 100%);
  color: white;
}

.card {
  transition: all 0.3s ease;
  border-radius: 8px;
  overflow: hidden;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.info-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.service-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  border-top: 4px solid #2563EB;
}

.rating-stars {
  color: #FBBF24;
}

.download-btn {
  transition: all 0.3s ease;
}

.download-btn:hover {
  background-color: #1D4ED8;
  transform: translateY(-2px);
}

.contact-btn {
  transition: all 0.3s ease;
}

.contact-btn:hover {
  background-color: white;
  color: #2563EB;
  transform: translateY(-2px);
}

.favorite-btn {
  transition: all 0.3s ease;
}

.favorite-btn:hover {
  background-color: #FEE2E2;
  color: #EF4444;
  transform: translateY(-2px);
}

.stat-card {
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  transition: all 0.3s ease;
}

.stat-card:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-5px);
}

.nav-link {
  position: relative;
  transition: all 0.3s ease;
}

.nav-link::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: -4px;
  left: 0;
  background-color: white;
  transition: width 0.3s ease;
}

.nav-link:hover::after {
  width: 100%;
}

.scroll-indicator {
  position: fixed;
  top: 0;
  left: 0;
  height: 3px;
  background-color: #2563EB;
  z-index: 1000;
  width: 0%;
}

.industry-tag {
  display: inline-block;
  background-color: #EBF5FF;
  color: #2563EB;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  margin-right: 6px;
  margin-bottom: 6px;
}

.exhibition-tag {
  display: inline-block;
  background-color: #EFF6FF;
  color: #1D4ED8;
  padding: 3px 12px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
}

.file-size {
  color: #6B7280;
  font-size: 13px;
  margin-left: 8px;
}

.view-all-btn {
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.view-all-btn:hover {
  background-color: #1D4ED8;
  transform: translateY(-2px);
}
</style>
